import { render, staticRenderFns } from "./ResetPasswordSuccess.vue?vue&type=template&id=4d3dedec&scoped=true"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordSuccess.vue?vue&type=style&index=0&id=4d3dedec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3dedec",
  null
  
)

export default component.exports